import React from 'react';
import { FileText, Image as ImageIcon } from 'lucide-react';

const ContentPreview = ({ content, hasText, hasImages }) => {
  if (!hasText && !hasImages) return null;

  return (
    <div className="space-y-2 mb-3 p-3 bg-slate-50 dark:bg-slate-800/60 rounded-lg border border-slate-200 dark:border-slate-700">
      <div className="text-xs font-semibold text-slate-600 dark:text-slate-300 mb-2">Contenido seleccionado:</div>

      {hasText && (
        <div className="flex items-start gap-2">
          <FileText className="w-4 h-4 text-sky-600 mt-0.5 flex-shrink-0" />
          <div className="text-xs text-slate-700 dark:text-slate-200 overflow-hidden">
            <span className="font-medium">Texto:</span>{' '}
            {content.text.substring(0, 100)}
            {content.text.length > 100 ? '...' : ''}
          </div>
        </div>
      )}

      {hasImages && (
        <div className="flex items-start gap-2">
          <ImageIcon className="w-4 h-4 text-purple-600 mt-0.5 flex-shrink-0" />
          <div className="text-xs text-slate-700 dark:text-slate-200">
            <span className="font-medium">Imágenes:</span>{' '}
            {content.images.length} seleccionada
            {content.images.length > 1 ? 's' : ''}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContentPreview;
